import './EventMapCSS.css'
import { useEffect, useRef } from 'react'
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer'
import { AddPoint, AddPopupTemplateForLocations, CreateMap, CreateView } from './EventMapSetup'
import { useAppContext } from '../../../context/AppSettingsContextProvider'
import { EventDto, LocationDto } from '../../../interfaces/IEvent'

interface EventMapProps {
  viewEvent: EventDto
}

function EventMap({ viewEvent }: EventMapProps) {
  const mapDiv = useRef<HTMLDivElement>(null)
  const { isDarkTheme } = useAppContext()

  useEffect(() => {
    if (mapDiv.current) {
      const map = CreateMap(isDarkTheme)
      CreateView(map, mapDiv, isDarkTheme)
      const graphicsLayer = new GraphicsLayer()
      map.add(graphicsLayer)

      viewEvent.affectedCustomers.forEach((customer) => {
        // Map for å gruppere adresser på koordinater
        const coordMap = new Map<string, LocationDto[]>()

        ;(customer.affectedAddresses ?? []).forEach((location: LocationDto) => {
          // Forutsetter at location har latitude og longitude
          const key = `${location.gisApiLocation?.y},${location.gisApiLocation?.x}`
          if (!coordMap.has(key)) {
            coordMap.set(key, [])
          }
          coordMap.get(key)!.push(location)
        })

        // Lag ett punkt per koordinat
        coordMap.forEach((locations, coordKey) => {
          const popupTemplate = AddPopupTemplateForLocations(customer, locations)
          AddPoint(graphicsLayer, popupTemplate, locations[0])
        })
      })
    }
  }, [isDarkTheme, viewEvent.affectedCustomers])

  return <div className="map" ref={mapDiv}></div>
}

export default EventMap
